import React from 'react';
import styled from '@emotion/styled';
import { useLocale } from 'locale';
import { TextLabel } from 'ds/components/typography';

export const TimeToGetToTitle: React.FunctionComponent<{}> = () => {
  const { t } = useLocale();
  return (
    <Title caps>{t('transportationPage.timeToGetTitle')}</Title>
  );
};

export const Title = styled(TextLabel)`
  display: flex;
  margin: 0 0 16px;
  color: ${({ theme }) => theme.colors.neutrals.grey3};
`;
